import { getUnusualEvents } from '../../api/unusual';
import { getAnalytics } from '../../api/analytics';
import { handleActionAbortController } from '../../utils/handleActionAbortController';

export const CHANGE_EMPTY_PAN_VALUE = 'CHANGE_EMPTY_PAN_VALUE';
export const CHANGE_EMPTY_PAN_SEVERAL_VALUES = 'CHANGE_EMPTY_PAN_SEVERAL_VALUES';
export const CHANGE_EMPTY_PAN_CURRENT_IMAGE = 'CHANGE_EMPTY_PAN_CURRENT_IMAGE';
export const SET_EMPTY_PAN_EVENT_IMAGE = 'SET_EMPTY_PAN_EVENT_IMAGE';
export const RESET_EMPTY_PAN_STORE = 'RESET_EMPTY_PAN_STORE';

export const GET_EMPTY_PAN = 'GET_EMPTY_PAN';
export const GET_EMPTY_PAN_SUCCESS = 'GET_EMPTY_PAN_SUCCESS';
export const GET_EMPTY_PAN_ERROR = 'GET_EMPTY_PAN_ERROR';

export const GET_EMPTY_PAN_ANALYTIC = 'GET_EMPTY_PAN_ANALYTIC';
export const GET_EMPTY_PAN_ANALYTIC_SUCCESS = 'GET_EMPTY_PAN_ANALYTIC_SUCCESS';
export const GET_EMPTY_PAN_ANALYTIC_ERROR = 'GET_EMPTY_PAN_ANALYTIC_ERROR';

export const getEmptyPanAction = (function () {
  let prevController;

  return (params, actions) => {
    return async (dispatch) => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;
      dispatch({ type: GET_EMPTY_PAN });
      try {
        const response = await getUnusualEvents(params, abortController.signal);
        const { success, results } = response;
        if (success && !abortController.signal.aborted) {
          dispatch({ type: GET_EMPTY_PAN_SUCCESS, payload: results, params });
          actions.onSuccess && actions.onSuccess(results.content);
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.log(error);
          dispatch({ type: GET_EMPTY_PAN_ERROR });
          actions.onError && actions.onError(error.message);
        }
      }
    };
  };
})();

export const getEmptyPanAnalyticAction = (function () {
  let prevController;

  return (params) => {
    return async (dispatch) => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;
      dispatch({ type: GET_EMPTY_PAN_ANALYTIC });
      try {
        const response = await getAnalytics(params, abortController.signal);
        const { success, results } = response;
        if (success && !abortController.signal.aborted) {
          dispatch({ type: GET_EMPTY_PAN_ANALYTIC_SUCCESS, payload: results, params });
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.log(error);
          dispatch({ type: GET_EMPTY_PAN_ANALYTIC_ERROR });
        }
      }
    };
  };
})();

export const changeValue = (key, value) => ({
  type: CHANGE_EMPTY_PAN_VALUE,
  payload: {
    key,
    value,
  },
});

export const changeSeveralValues = (value) => ({
  type: CHANGE_EMPTY_PAN_SEVERAL_VALUES,
  payload: value,
});

export const changeCurrentImage = (index, value) => ({
  type: CHANGE_EMPTY_PAN_CURRENT_IMAGE,
  payload: { index, value },
});

export const setEventImage = (eventId, index, image) => ({
  type: SET_EMPTY_PAN_EVENT_IMAGE,
  payload: { eventId, index, image },
});

export const resetStore = () => ({
  type: RESET_EMPTY_PAN_STORE,
});
